<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @imp="imp" @exps="exp"  @save="save"
                    ref="SetBtn"></buttonlist>
        <!-- 功能按钮 -->
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <div style="margin-top: 2px">
                    <el-button type="primary" size="mini" @click="batchAudit" :disabled="!btn.batchaudit">{{$t('getapi[1315]')}}</el-button>
                    <el-button type="primary" size="mini" @click="batchUnAudit" :disabled="!btn.batchunaudit">{{$t('getapi[1316]')}}</el-button>
                    <el-button type="primary" size="mini" @click="batchUpdate">{{$t('getapi[12913]')}}</el-button>
                    <el-button type="primary" size="mini" @click="salBatchUpdate" :disabled="!btn.salbatchupdate">{{$t('getapi[13268]')}}</el-button>
                </div>
                <!-- 表格 -->
                <wTable
                        id="xpane-0"
                        :data="datajson"
                        :loading="loading"
                        queryData="SALPartViewInfo"
                        :filter_language="['audit_status',,'Batch_Price_Flag','part_statusname']"
                        :filter_thousandth="['Price','net_Price','package_size']"
                        :header="tableHeader"
                        :option="tableOption"
                        @handleSelectionChange="handleSelectionChange"
                        @edits="edits"
                        @rowdblclick="openEdit"
                        ref="singleTable"
                ></wTable>
                <!--<el-table
                        :data="datajson"
                        v-loading="loading"
                        show-overflow-tooltip="true"
                        ref="singleTable"
                        border
                        stripe
                        size="mini"
                        header-row-class-name="headerclass"
                        :height="tableHeight - reduceTableHeight"
                        tab-click="selectInfo(0)"
                        @selection-change="handleSelectionChange"
                        @current-change="handleCurrentChanges"
                        :highlight-current-row="true"
                        @row-click="edits"
                        @row-dblclick="openEdit"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Exclusively_ID" label="ID"
                                     v-if="false" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Sales_part" :label="$t('getapi[2652]')" width="100" sortable>
                        <template scope="scope">
                            <input type="text" class="fsd clerinput" @keydown="shows($event, scope.$index)"
                                   @keyup="show($event, scope)" v-model="scope.row.Sales_part" readonly/>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Part_Version" :label="$t('getapi[2654]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Part_name" :label="$t('getapi[2653]')"
                                     width="200" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="cust_version" :label="$t('getapi[6352]')"
                                     width="100" sortable></el-table-column>
                    &lt;!&ndash; 	<el-table-column show-overflow-tooltip prop="sal_Price" :label="$t('getapi[6017]')" width="100" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="sal_net_Price" :label="$t('getapi[6018]')" width="100" align="right"></el-table-column> &ndash;&gt;
                    <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[3437]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_name" :label="$t('getapi[546]')"
                                     width="200" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Model" :label="$t('getapi[124]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Spec" :label="$t('getapi[125]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Sales_Unit_Name" :label="$t('getapi[2658]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Inv_Unit_Name" :label="$t('getapi[1340]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Change_rate" :label="$t('getapi[6466]')" width="100"
                                     align="right" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Price" :label="$t('getapi[1292]')" width="100"
                                     align="right" v-if="authority_showprice" sortable>
                        <template slot-scope="scope">
                            {{ scope.row.Price | tofixed4 }}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="net_Price" :label="$t('getapi[1352]')" width="100"
                                     align="right" v-if="authority_showprice" sortable>
                        <template slot-scope="scope">
                            {{ scope.row.net_Price | tofixed4 }}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Currency_Unit" :label="$t('getapi[1338]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Package_Name" :label="$t('getapi[3417]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Sales_Type_Name" :label="$t('getapi[2656]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="CusPart_ID" :label="$t('getapi[2390]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="CusPart_Name" :label="$t('getapi[2391]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_person" :label="$t('getapi[410]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_time" :label="$t('getapi[135]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Update_person" :label="$t('getapi[733]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="update_time" :label="$t('getapi[1210]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_status" :label="$t('getapi[2660]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Batch_Price_Flag" :label="$t('getapi[1298]')"
                                     width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="package_size" :label="$t('getapi[6353]')" width="100"
                                     align="right" sortable></el-table-column>
                    &lt;!&ndash;<el-table-column show-overflow-tooltip :label="$t('basic.edit')" width="120">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="edit(scope)" type="text" size="mini">{{ $t('getapi[34]')
                                }}
                            </el-button>
                        </template>
                    </el-table-column>&ndash;&gt;
                    <el-table-column show-overflow-tooltip prop="Tag_Single" :label="$t('getapi[6382]')" width="100" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Tag_Packag" :label="$t('getapi[6383]')" width="100" sortable></el-table-column>
                </el-table>-->
                <!-- 表格 -->
            </li>

            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <el-button type="primary" size="mini" icon="" @click="handleCommand(1)" :disabled="!btn.Audit">
                    {{$t('getapi[941]')}}
                </el-button>
                <el-button type="primary" size="mini" icon="" @click="handleCommand(0)" :disabled="!btn.RAudit">
                    {{$t('getapi[1334]')}}
                </el-button>
                <div style="width:800px;min-width:800px">
                    <table>
                        <tr>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2652]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <routejump :urlNo="12"  v-show="!isEdit">
                                <el-input
                                        v-model="formInline.Sales_part"
                                        :placeholder="$t('getapi[2652]')"
                                        style="width: 120px;"
                                        class="mcolor"
                                        readonly
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="ssf"></i>
                                </el-input>
                                </routejump>
                                <el-input
                                        style="width: 120px;"
                                        v-show="isEdit"
                                        v-model="formInline.Sales_part"
                                        :placeholder="$t('getapi[2652]')"
                                        suffix-icon="el-icon-edit"
                                        readonly
                                ></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2653]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-model="formInline.Part_name"
                                          :placeholder="$t('getapi[2653]')"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[8201]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-model="formInline.Cust_Version" :placeholder="$t('getapi[8201]')"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2390]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-model="formInline.CusPart_ID"
                                          :placeholder="$t('getapi[2390]')"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[2391]') }}</span></td>
                            <td><el-input v-model="formInline.CusPart_Name"
                                          :placeholder="$t('getapi[2391]')"></el-input></td>
                            <td><span>{{ $t('getapi[2660]') }}</span></td>
                            <td>
                                <el-select filterable v-model="formInline.audit_status" disabled>
                                    <el-option :label="$t('getapi[3607]')" :value="1"></el-option>
                                    <el-option :label="$t('getapi[2662]')" :value="0"></el-option>
                                </el-select>
                            </td>
                            <td><span>{{ $t('getapi[8595]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.cus_chartnum"
                                          :placeholder="$t('getapi[8595]')"></el-input>
                            </td>
                            <td><span v-if="LoginUser.Login_DB != 'MY' ">{{ $t('getapi[12832]') }}</span></td>
                            <td>
                                <el-input v-model="formInline.sales_rate" v-if="LoginUser.Login_DB != 'MY' "
                                          :placeholder="$t('getapi[12832]')"></el-input>
                            </td>
                            <td >
                                <el-checkbox :true-label="1" :false-label="0" v-model="formInline.isestimateprice" >{{ $t('getapi[10314]') }}</el-checkbox>
                            </td>
                        </tr>
                    </table>
                </div>
                <!--<div class="box">
                    <div class="bbl">
                        <el-button type="primary" size="mini" icon="" @click="handleCommand(1)" :disabled="!btn.Audit">
                            {{$t('getapi[941]')}}
                        </el-button>
                        <el-button type="primary" size="mini" icon="" @click="handleCommand(0)" :disabled="!btn.RAudit">
                            {{$t('getapi[1334]')}}
                        </el-button>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[2652]') }}</span>
                        <el-input
                                v-show="!isEdit"
                                v-model="formInline.Sales_part"
                                :placeholder="$t('getapi[2652]')"
                                style="width: 120px;"
                                class="mcolor"
                                readonly
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="ssf"></i>
                        </el-input>
                        <el-input
                                style="width: 120px;"
                                v-show="isEdit"
                                v-model="formInline.Sales_part"
                                :placeholder="$t('getapi[2652]')"
                                suffix-icon="el-icon-edit"
                                readonly
                        ></el-input>
                        <span>{{ $t('getapi[2653]') }}</span>
                        <el-input style="width: 120px;" v-model="formInline.Part_name"
                                  :placeholder="$t('getapi[2653]')"></el-input>
                        <span>{{$t('getapi[8201]')}}</span>
                        <el-input style="width: 120px;" v-model="formInline.Cust_Version" :placeholder="$t('getapi[8201]')"></el-input>
                        <span>{{ $t('getapi[2390]') }}</span>
                        <el-input style="width: 120px;" v-model="formInline.CusPart_ID"
                                  :placeholder="$t('getapi[2390]')"></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[2391]') }}</span>
                        <el-input style="width: 120px;" v-model="formInline.CusPart_Name"
                                  :placeholder="$t('getapi[2391]')"></el-input>
                        <span>{{ $t('getapi[2660]') }}</span>
                        <el-select style="width: 120px;" filterable v-model="formInline.audit_status" disabled>
                            <el-option :label="$t('getapi[3607]')" :value="1"></el-option>
                            <el-option :label="$t('getapi[2662]')" :value="0"></el-option>
                        </el-select>
                        <span>{{ $t('getapi[8595]') }}</span>
                        <el-input style="width: 120px;" v-model="formInline.cus_chartnum"
                                  :placeholder="$t('getapi[8595]')"></el-input>
                        &lt;!&ndash; <span>{{ $t('getapi[10314]') }}</span> &ndash;&gt;
                        <el-checkbox :true-label="1" :false-label="0" v-model="formInline.isestimateprice" >{{ $t('getapi[10314]') }}</el-checkbox>
                    </div>
                </div>-->
                <!-- 编辑弹框 -->
                <el-row>
                    <el-col :span="24">
                        <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="100px"
                                 label-position="left" size="small">
                            <el-tabs :style="{ height: tableHeight - 117 + 'px' }">
                                <el-tab-pane :label="$t('getapi[11]')">
                                    <div style="width:740px;min-width:740px">
                                        <table>
                                            <tr>
                                                <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2656]') }}</span></td>
                                                <td style="width:120px;min-width:120px">
                                                    <routejump :urlNo="34">
                                                    <el-select filterable v-model="formInline.Sales_Type" class="mcolor" size="mini">
                                                        <el-option v-for="item in Sales_Type" :label="item.TypeName"
                                                                   :value="item.Exclusively_Id"
                                                                   :key="item.Exclusively_Id"></el-option>
                                                    </el-select>
                                                    </routejump>
                                                </td>
                                                <td style="width:80px;min-width:80px"><span>{{ $t('getapi[3417]') }}</span></td>
                                                <td style="width:120px;min-width:120px">
                                                    <routejump :urlNo="35">
                                                    <el-select filterable v-model="formInline.Package" class="mcolor" size="mini">
                                                        <el-option v-for="item in Package" :label="item.TypeName"
                                                                   :value="item.Exclusively_Id"
                                                                   :key="item.Exclusively_Id"></el-option>
                                                    </el-select>
                                                    </routejump>
                                                </td>
                                                <td style="width:80px;min-width:80px"><span>{{ $t('getapi[135]') }}</span></td>
                                                <td style="width:120px;min-width:120px">
                                                    <el-input v-model="formInline.Create_time" :placeholder="$t('getapi[135]')"
                                                              size="mini" :readonly="true" class="readO"></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[2666]') }}</span></td>
                                                <td>
                                                    <el-input v-model="formInline.Sales_part" :placeholder="$t('getapi[2666]')"
                                                              size="mini" :readonly="true" class="readO"></el-input>
                                                </td>
                                                <td><span>{{ $t('getapi[2664]') }}</span></td>
                                                <td colspan="3">
                                                    <el-input v-model="formInline.Part_name" :placeholder="$t('getapi[2664]')"
                                                              size="mini" :readonly="true" class="readO"></el-input>
                                                </td>
                                                <td style="width:80px;min-width:80px"><span>{{ $t('getapi[149]') }}</span></td>
                                                <td style="width:120px;min-width:120px">
                                                    <el-input v-model="formInline.Part_Version" :placeholder="$t('getapi[149]')"
                                                              size="mini" :readonly="true" class="readO"></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[124]') }}</span></td>
                                                <td>
                                                    <el-input v-model="formInline.Model" :placeholder="$t('getapi[124]')"
                                                               size="mini"></el-input>
                                                </td>
                                                <td><span>{{ $t('getapi[125]') }}</span></td>
                                                <td><el-input v-model="formInline.Spec" :placeholder="$t('getapi[125]')"
                                                              size="mini"></el-input></td>
                                                <td><span>{{ $t('getapi[827]') }}</span></td>
                                                <td>
                                                    <el-input v-model="formInline.item_name" :placeholder="$t('getapi[827]')" size="mini" :readonly="true" class="readO"></el-input>
                                                </td>
                                                <td><span>{{ $t('getapi[12873]') }}</span></td>
                                                <td>
                                                    <el-input v-model="formInline.sal_moq" :placeholder="$t('getapi[12873]')"
                                                            size="mini"  ></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[1340]') }}</span></td>
                                                <td>
                                                    <el-input v-model="formInline.Inv_Unit_Name"
                                                              :placeholder="$t('getapi[1340]')" size="mini"
                                                              :readonly="true" class="readO"></el-input>
                                                </td>
                                                <td><span>{{ $t('getapi[2658]') }}</span></td>
                                                <td>
                                                    <routejump :urlNo="1">
                                                    <el-select
                                                            filterable
                                                            v-model="formInline.Sales_Unit"
                                                            class="mcolor"
                                                            size="mini"
                                                            :disabled="formInline.audit_status != 0"
                                                    >
                                                        <el-option v-for="item in Inv_Unit" :label="item.Name" :value="item.Num"
                                                                   :key="item.Num"></el-option>
                                                    </el-select>
                                                    </routejump>
                                                </td>
                                                <td><span>{{ $t('getapi[1304]') }}</span></td>
                                                <td><el-input v-model="formInline.Change_rate" :placeholder="$t('getapi[1304]')"
                                                              size="mini"></el-input></td>
                                                <td><span>{{ $t('getapi[555]') }}</span></td>

                                                <td><el-checkbox  v-model="formInline.isfreeze" :true-label=1 :disabled="btn.isfreeze"
                                                    :false-label=0></el-checkbox></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[1338]') }}</span></td>
                                                <td>
                                                    <routejump :urlNo="24">
                                                    <el-select
                                                        filterable
                                                        v-model="formInline.Currency_Unit"
                                                        class="mcolor"
                                                        size="mini"
                                                        :disabled="formInline.audit_status != 0"
                                                        @change="currencycodeChange"
                                                >
                                                    <el-option v-for="item in Currency_Unit" :label="item.Code"
                                                               :value="item.Code" :key="item.Code"></el-option>
                                                </el-select>
                                                    </routejump></td>
                                                <td><span>{{ $t('getapi[1292]') }}</span></td>
                                                <td>
                                                    <el-input
                                                            v-model="formInline.Price"
                                                            :placeholder="$t('getapi[1292]')"
                                                            size="mini"
                                                            class="mcolor"
                                                            :readonly="formInline.audit_status != 0"
                                                            :class="{'readO':formInline.audit_status != 0}"
                                                            @input="priinpu"
                                                            type="number"
                                                            autocomplete="off" title=""
                                                            @mousewheel.native.prevent
                                                            v-if="authority_showpriceedit"
                                                    ></el-input>
                                                    <el-input
                                                            v-model="formInline.Price"
                                                            size="mini"
                                                            :readonly="true" class="readO"
                                                            type="password"
                                                            v-if="!authority_showpriceedit"></el-input>
                                                </td>                                                
                                                <td><span>{{ $t('getapi[1352]') }}</span></td>
                                                <td>
                                                    <el-input
                                                            v-model="formInline.net_Price"
                                                            :placeholder="$t('getapi[1352]')"
                                                            size="mini"
                                                            :readonly="formInline.audit_status != 0"
                                                            :class="{'readO':formInline.audit_status != 0}"
                                                            @input="priinput"
                                                            type="number"
                                                            autocomplete="off" title=""
                                                            @mousewheel.native.prevent
                                                            v-if="authority_showpriceedit"
                                                    ></el-input>
                                                    <el-input
                                                            v-model="formInline.net_Price"
                                                            size="mini"
                                                            :readonly="true" class="readO"
                                                            type="password"
                                                            v-if="!authority_showpriceedit">
                                                    </el-input>
                                                </td>
                                                <td><span>{{ $t('getapi[12969]') }}</span></td>
                                                <td>
                                                    <el-input v-model="formInline.customsname" :placeholder="$t('getapi[12969]')" size="mini"></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[3437]') }}</span></td>
                                                <td><el-input v-model="formInline.item_code" :placeholder="$t('getapi[3437]')"
                                                               size="mini" :readonly="true" class="readO"></el-input></td>
                                                <td><span>{{ $t('getapi[6353]') }}</span></td>
                                                <td><el-input v-model="formInline.package_size" :placeholder="$t('getapi[6353]')"
                                                               size="mini"></el-input></td>
                                                <td><span>{{ $t('getapi[8955]') }}</span></td>
                                                <td><el-input v-model="formInline.processing" :placeholder="$t('getapi[8955]')"
                                                               size="mini"></el-input></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[143]') }}</span></td>
                                                <td colspan="5">
                                                    <el-input v-model="formInline.Remark" :placeholder="$t('getapi[143]')"
                                                               size="mini" type="textarea"></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[6382]') }}</span></td>
                                                <td><el-input v-model="formInline.Tag_Single"
                                                              size="mini" :readonly="formInline.audit_status != 0" :class="{'readO':formInline.audit_status != 0}"></el-input></td>
                                                <td><span>{{ $t('getapi[6383]') }}</span></td>
                                                <td>
                                                    <el-input v-model="formInline.Tag_Packag"
                                                              size="mini" :readonly="formInline.audit_status != 0" :class="{'readO':formInline.audit_status != 0}"></el-input>
                                                </td>
                                                <td><span>{{ $t('getapi[8008]') }}</span></td>
                                                <td>
                                                    <el-input v-model="formInline.package_spec"
                                                              size="mini" :readonly="formInline.audit_status != 0" :class="{'readO':formInline.audit_status != 0}"></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[12858]') }}</span></td>
                                                <td>
                                                    <el-input v-model="formInline.custdraw_version"
                                                              size="mini"></el-input>
                                                </td>
                                                <td v-if="curratelist.a125 == 1 && formInline.Sales_part.toLowerCase().endsWith('-bc')"><span>{{ $t('getapi[13011]') }}</span></td>
                                                <td v-if="curratelist.a125 == 1 && formInline.Sales_part.toLowerCase().endsWith('-bc')">
                                                    <el-input v-model="formInline.base_price" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                              size="mini" @input="changeBasePrice"></el-input>
                                                </td>
                                                <td v-if="curratelist.a125 == 1 && formInline.Sales_part.toLowerCase().endsWith('-bc')"><span>{{ $t('getapi[13012]') }}</span></td>
                                                <td v-if="curratelist.a125 == 1 && formInline.Sales_part.toLowerCase().endsWith('-bc')">
                                                    <el-input v-model="formInline.base_net_price" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                              size="mini" @input="changeBaseNetPrice"></el-input>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane :label="$t('getapi[1298]')">
                                    <el-button type="primary" size="mini" icon="el-icon-circle-plus"
                                               @click="addline('')" :disabled="!btn.add">{{$t('getapi[6467]')}}
                                    </el-button>
                                    <el-table
                                            :data="Detail"
                                            v-loading="loading"
                                            :highlight-current-row="false"
                                            show-overflow-tooltip="true"
                                            border
                                            stripe
                                            size="mini"
                                            :height="tableHeight - 150"
                                            header-row-class-name="headerclass"
                                            v-show="isEdit"
                                            style="margin-top: 2px"
                                    >
                                       <!-- <el-table-column show-overflow-tooltip prop="_exclusively_id"
                                                         :label="$t('getapi[589]')" align="right"></el-table-column>-->
                                        <el-table-column show-overflow-tooltip prop="_batch_floor_limit"
                                                         :label="$t('getapi[1351]')" align="right"></el-table-column>
                                        <el-table-column show-overflow-tooltip prop="_price" :label="$t('getapi[1292]')"
                                                         align="right"></el-table-column>
                                        <el-table-column show-overflow-tooltip prop="_net_price"
                                                         :label="$t('getapi[1352]')" align="right" v-if="curratelist.a125 == 1"></el-table-column>
                                        <el-table-column show-overflow-tooltip prop="_base_price" :label="$t('getapi[13011]')"
                                                         align="right"></el-table-column>
                                        <el-table-column show-overflow-tooltip prop="_base_net_price"
                                                         :label="$t('getapi[13012]')" align="right" v-if="curratelist.a125 == 1"></el-table-column>
                                        <el-table-column prop="operate" :label="$t('getapi[6048]')">
                                            <template slot-scope="scope">
                                                <el-button @click.native.prevent="dels(scope)" type="text" size="mini"
                                                           :disabled="!btn.rowdel">{{ $t('getapi[40]') }}
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <el-table
                                            :data="Detail"
                                            v-loading="loading"
                                            :highlight-current-row="false"
                                            show-overflow-tooltip="true"
                                            border
                                            stripe
                                            size="mini"
                                            :height="tableHeight - 150"
                                            header-row-class-name="headerclass"
                                            v-show="!isEdit"
                                            style="margin-top: 3px"
                                    >
                                        <!-- <el-table-column show-overflow-tooltip prop="_exclusively_id" :label="$t('getapi[589]')" align="right">
                                                <template slot-scope="scope">
                                                    <el-input v-model="scope.row._exclusively_id" type="number"></el-input>
                                                </template>
                                            </el-table-column> -->
                                        <el-table-column prop="_batch_floor_limit"
                                                         :label="$t('getapi[1351]')" align="right">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row._batch_floor_limit" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                          step="0.0001" onchange="if(value<=0)value=''"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="_price" :label="$t('getapi[1292]')"
                                                         align="right">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row._price" type="number" autocomplete="off" title="" @mousewheel.native.prevent step="0.0001"
                                                          @change="cahngeprice(scope)"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="_net_price"
                                                         :label="$t('getapi[1352]')" align="right">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row._net_price" type="number" autocomplete="off" title="" @mousewheel.native.prevent step="0.0001"
                                                          @change="cahngenetprice(scope)"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="_base_price" :label="$t('getapi[13011]')"
                                                         align="right" v-if="curratelist.a125 == 1">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row._base_price" type="number" autocomplete="off" title="" @mousewheel.native.prevent step="0.0001"
                                                          @change="changebaseprice(scope)"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="_base_net_price"
                                                         :label="$t('getapi[13012]')" align="right" v-if="curratelist.a125 == 1">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row._base_net_price" type="number" autocomplete="off" title="" @mousewheel.native.prevent step="0.0001"
                                                          @change="changebasenetprice(scope)"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="operate" :label="$t('getapi[6048]')">
                                            <template slot-scope="scope">
                                                <el-button @click.native.prevent="dels(scope)" type="text" size="mini">
                                                    {{ $t('getapi[40]') }}
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-tab-pane>
                            </el-tabs>
                        </el-form>
                    </el-col>
                </el-row>
                <!-- 编辑弹框 -->
            </li>
        </ul>
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="16">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[50, 100, 200, 300, 400]"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="8">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{ $t('getapi[7980]')
                    }}:{{ DbTbNames }}
                </div>
            </el-col>
        </el-row>
        <!-- 分页 -->
        <!-- 搜索弹框 -->
        <serce :isVisible="false" queryData="SALPartViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[999]')" queryData="SALPartViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!-- 搜索弹框 -->
        <el-dialog v-dialogDrag :visible.sync="updateVis" :title="$t('getapi[12913]')" width="500px"  :close-on-click-modal="false">
            <el-divider></el-divider>
            <div>
                <table>
                    <tr>
                        <td>{{$t('getapi[346]')}}</td>
                        <td><el-input v-model="updateData.person" type="text" size="mini" :disabled="true"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[13009]')}}</td>
                        <td><el-input v-model="updateData.discount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" ></el-input></td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>
            <el-table
                    :data="dataDiscount"
                    :highlight-current-row="false"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    height="300"
                    tab-click="selectInfo(0)"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
                    :header-cell-style="$limits.headerClass"

            >
                <el-table-column show-overflow-tooltip prop="discount"
                                 :label="$t('getapi[13009]')" width="60"></el-table-column>
                <el-table-column show-overflow-tooltip prop="create_person"
                                 :label="$t('getapi[410]')" width="80"></el-table-column>
                <el-table-column show-overflow-tooltip prop="create_time"
                                 :label="$t('getapi[2950]')" width="120"></el-table-column>
                <el-table-column show-overflow-tooltip prop="remark"
                                 :label="$t('getapi[143]')"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="updateVis = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" :disabled="!btn.batchupdate" @click="confirmBatchUpdate">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>
        <!-- 销售件弹框 -->
        <!-- <itemtask :isVisible="salssvisi" @getitem="getitem" ref="input"></itemtask> -->
        <selector :isVisible="salssvisi" :isSplitPage=true :postUrl="'/Sal/Part/GetSalPartPopupList'"
                  @callback="getitem" ref="input"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import urlpost from '@/api/config.js';
    import authority from "../../../../utils/authority";
    import { Loading } from 'element-ui';
    export default {
        name: 'saltaskinfo',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                Sales_Type: [], //销售类别
                Package: [], //包装方式
                Currency_Unit: [], //货币
                Inv_Unit: [], //库存计量单位
                currate: [], //税率
                curratelist:{
                    "currencycode": "",
                    "taxrate": "",
                    "a125": "",
                    "discount": ""
                },
                currencycode: '',//企业税率代码
                Detail: [
                    {
                        _exclusively_id: '',
                        _p_part_id: 0,
                        _batch_floor_limit: '',
                        _price: 0,
                        _net_price: 0,
                        _base_price:'',
                        _base_net_price:'',
                        _relation_id: 0
                    }
                ],
                salssvisi: false,
                filelist: [],
                ids: '',
                showloading: '',
                isVisible: false,
                editvisi: false,
                isEdit: false,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('saltaskinfo'),
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight3,
                queryData: [], // 查询数组
                currentRow: null,
                lineid: [],
                formInline: {
                    Exclusively_Id: '',
                    Sales_part: '',
                    Part_name: '',
                    Part_Version: '',
                    Cust_Version: '',
                    Field: '',
                    CusPart_ID: '',
                    CusPart_Name: '',
                    Model: '',
                    Spec: '',
                    Sales_Type: null,
                    Part_No: '',
                    HelpCheck_Code: '',
                    Inv_Unit: '',
                    Sales_Unit: '',
                    Change_rate: '',
                    Price: '',
                    net_Price: '',
                    Currency_Unit: '',
                    Package: null,
                    Create_person: '',
                    Create_time: '',
                    Update_person: '',
                    update_time: '',
                    Remark: '',
                    MTL_Master_Unit: '',
                    part_name: '',
                    part_code: '',
                    MTL_Vension: '',
                    item_code: '',
                    item_name: '',
                    audit_status: 0,
                    Quoprice: '',
                    Package_size: 0,
                    isestimateprice:0,
                    sales_rate:1,
                    isfreeze:0
                },
                oldFormInline:'',
                exclusively_id: 0,
                btn: {
                    //审核
                    Audit: false,
                    //反审核
                    RAudit: false,
                    //删除明细
                    rowdel: false,
                    //新增行
                    add: false,
                    batchaudit: false,
                    batchunaudit: false,
                    batchupdate: true,//批量折扣
                    isfreeze:false,
                    salbatchupdate: false,//更新折扣价
                },
                selectData: [], //多选合集
                authority_showprice: false, // 一览，是否显示价格权限
                authority_showpriceedit: false, // 编辑，是否显示价格权限
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                userinfo: {},
                scrollTop:0,
                LoginUser: [], // 用户信息
                updateVis:false,//折扣记录表
                dataDiscount:[],
                updateData:{
                    person: '',
                    discount:0,
                },
            };
        },
        create() {
            this.getselect();
        },
        beforeMount() {
            // console.log('beforeMount');
            let that = this;
            that.getselect();
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            console.log('mounted');
            let that = this;
            that.colsort();
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.LoginUser= JSON.parse(sessionStorage.getItem('userData'));
            var users = sessionStorage.getItem('userData');
            that.userinfo = JSON.parse(users);
            that.$processdata.pushModelCache('saltaskinfo', that)
            that.$limits.dragControllerDiv();
            that.oldFormInline = JSON.stringify(that.formInline)
            //that.intidata();
            that.confirmAdd()
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[999]"),this.$t("getapi[14]"));
            },
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('SALPartViewInfo',0,PFileds=>{
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                // 价格是否显示
                console.log(that.$limits.authority('plv4', 64, 1))
                if(that.$limits.authority('plv4', 64, 1) > 0){
                    that.authority_showprice = true
                } else {
                    that.authority_showprice = false
                }
                if(that.$limits.authority('plv4', 65, 1) > 0){
                    that.authority_showpriceedit = true
                } else {
                    that.authority_showpriceedit = false
                }
                if(!this.$limits.menuvisible("plv2", 101, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 100, 1, that.total);
                    if(that.$limits.authority('plv2', 115, 1) > 0){
                        value = value + ',import'
                    }
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 101, 1) == 1) {
                        //只读权
                        if(that.$limits.authority('plv2', 115, 1) > 0){//导入权限
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,import,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                    }
                    if (that.$limits.authority('plv2', 101, 1) == 2) {
                        if (that.$limits.authority('plv3', 101,1) == 0) {
                            if(that.$limits.authority('plv2', 115, 1) > 0){//导入权限
                                that.$refs.SetBtn.SetButtonEnable('search,refresh,import,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            }
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 101,1) == 1) {
                            //编辑级
                            if(that.$limits.authority('plv2', 115, 1) > 0){
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,import,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                            /*if (!that.$limits.fnIsEmpty(that.formInline.Exclusively_Id)) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,import,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,import,refresh,export');
                            }*/
                        }
                        if (that.$limits.authority('plv3', 101, 1) == 2) {
                            //删除级
                            if(that.$limits.authority('plv2', 115, 1) > 0){
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,import,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                            /*if (!that.$limits.fnIsEmpty(that.formInline.Exclusively_Id)) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,import,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,import,refresh,export');
                            }*/
                        }
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                that.btn.add = false;
                that.btn.isfreeze=false;
                that.btn.salbatchupdate = false
                if (that.$limits.authority('plv4', 588, 1) == 1) {
                    that.btn.isfreeze = false;
                } else {
                    that.btn.isfreeze = true;
                }
                if (that.$limits.authority('plv4', 231, 1) == 1) {
                    that.btn.salbatchupdate = false;
                } else {
                    that.btn.salbatchupdate = true;
                }
                if (that.formInline.audit_status == 0) {
                    that.isEdit = false;
                    that.btn.add = true;
                }
                else {
                    that.isEdit = true;
                    that.btn.add = false;
                }
                //审核
                that.btn.Audit = false;
                //反审核
                that.btn.RAudit = false;
                //删除明细
                that.btn.rowdel = false;
                if (that.$limits.authority('plv4', 333, 1) == 1) {
                    //审核
                    that.btn.Audit = true;
                    //反审核
                    that.btn.RAudit = true;
                } else {
                    //审核
                    that.btn.Audit = false;
                    //反审核
                    that.btn.RAudit = false;
                    return;
                }
                console.log('测试：' + that.formInline.audit_status);
                if (that.formInline.audit_status == 0) {
                    //审核
                    that.btn.Audit = true;
                    //反审核
                    that.btn.RAudit = false;
                } else {
                    //审核
                    that.btn.Audit = false;
                    //反审核
                    that.btn.RAudit = true;
                }
                if (that.formInline.audit_status != 1) {
                    that.btn.rowdel = true;
                }
                that.btn.batchaudit = false
                that.btn.batchunaudit = false
                if(that.selectData.length > 0 ){
                    that.btn.batchaudit = that.selectData.every(val => {
                        return val.audit_status == '未审'
                    });
                    that.btn.batchunaudit = that.selectData.every(val => {
                        return val.audit_status == '已审'
                    });
                }
            },

            //字符转数字
            // PageIndex()
            //获取查询条件
            serclick(val) {
                // console.log(val);
                this.queryData = val;
                this.intidata();
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('saltaskinfo',val)
                this.intidata();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
            },
            //获取权限
            getselect() {
                let that = this;
                let parm = {};
                //销售类别
                that.$http.urlpost('Basic/Sale/GetSalTypeList', parm, function (res) {
                    if (res.Success == 1) {
                        console.log(res);
                        that.Sales_Type = res.DataContent;
                        //Sales_Type: [], //销售类别
                    }
                });
                //包装方式
                that.$http.urlpost('Basic/Sale/GetPuckTypeList', parm, function (res) {
                    if (res.Success == 1) {
                        console.log(res);
                        that.Package = res.DataContent;
                        //Package: [], //包装方式
                    }
                });
                //货币
                that.$http.urlpost('Basic/GetCurrencyList', parm, function (res) {
                    if (res.Success == 1) {
                        console.log(res);
                        that.Currency_Unit = res.DataContent;
                        //Currency_Unit:[],//货币
                    }
                });
                //库存计量单位
                that.$http.urlpost('Basic/GetAllUnits', parm, function (res) {
                    if (res.Success == 1) {
                        console.log(res);
                        that.Inv_Unit = res.DataContent;
                        //Inv_Unit:[],//库存计量单位
                    }
                });
                //获取税率
                // "currencycode": "CNY",
                //      "taxrate": "13.0000"
                that.$http.urlpost('Basic/GetCurARate', parm, function (res) {
                    if (res.Success == 1) {
                        console.log("企业货币:" + res.DataContent[0].currencycode);
                        that.currate = res.DataContent;
                        that.curratelist = res.DataContent[0]
                    }
                });
            },
            //删除行
            dels(e) {
                let that = this;
                if (!that.$limits.fnIsEmpty(e.row._exclusively_id)) {
                    let parm = {
                        exclusively_id: that.exclusively_id,
                        lineid: e.row._exclusively_id,
                    };
                    console.log(parm);
                    that.$http.urlpost('Sal/Part/DeleteBatchPriceByID', parm, function (res) {
                        that.intidata();
                        if (res.Success == 1) {
                            let ppms = {
                                Exclusively_Id: that.exclusively_id,
                            };
                            that.getdetail(ppms);
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    });
                }

            },
            //新增一行批量价格
            addline(line) {
                let that = this;
                if(line == ''){
                    that.Detail = [...that.Detail,{
                        add: false,
                        _exclusively_id: '',
                        _p_part_id: 0,
                        _batch_floor_limit: '',
                        _price: 0,
                        _net_price: 0,
                        _base_price:'',
                        _base_net_price:'',
                        _relation_id: 0
                    }]
                } else {
                    let detail = that.Detail;
                    var index = that.Detail.length - 1;
                    if (!that.$limits.fnIsEmpty(that.Detail[index]._price)) {
                        let deti = {
                            add: false,
                            _exclusively_id: '',
                            _p_part_id: 0,
                            _batch_floor_limit: '',
                            _price: 0,
                            _net_price: 0,
                            _base_price:'',
                            _base_net_price:'',
                            _relation_id: 0
                        };
                        that.Detail.push(deti);
                        this.isEdit = false;
                    }
                }
            },
            //批量价格输入
            inputs(e, i) {
                console.log(e);
                let ind = e.$index;
                let pp = 0;
                this.currate.forEach(item => {
                    if (item.currencycode == this.formInline.Currency_Unit) {
                        pp = item.taxrate / 100;
                    }
                });
                console.log(pp);
                if (i == 0) {
                    let price = e.row._price / (1 + pp);
                    this.Detail[ind]._net_price = price.toFixed(4);
                }
                if (i == 1) {
                    let price = e.row._net_price * (1 + pp);
                    this.Detail[ind]._price = price.toFixed(4);
                }
                this.addline(ind);
            },

            //价格输入
            priinput(e) {
                let that = this;
                let pp = 0;
                this.currate.forEach(item => {
                    if (item.currencycode == this.formInline.Currency_Unit) {
                        pp = item.taxrate / 100;
                        that.currencycode = item.currencycode;
                    }
                });
                console.log(pp);
                let price = e * (1 + pp);
                this.formInline.Price = price.toFixed(4);
                this.formInline.base_net_price = '';
                this.formInline.base_price = '';
            },
            priinpu(e) {
                let that = this;
                let pp = 0;
                this.currate.forEach(item => {
                    if (item.currencycode == this.formInline.Currency_Unit) {
                        pp = item.taxrate / 100;
                        that.currencycode = item.currencycode;
                    }
                });
                console.log(pp);
                let price = e / (1 + pp);
                this.formInline.net_Price = price.toFixed(4);
                this.formInline.base_net_price = '';
                this.formInline.base_price = '';
            },
            changeBasePrice(e){
                let that = this
                let pp = 0;
                let dis = this.curratelist.discount
                this.currate.forEach(item => {
                    if (item.currencycode == this.formInline.Currency_Unit) {
                        pp = item.taxrate / 100;
                        that.currencycode = item.currencycode;
                    }
                });
                let price = e / (1 + pp);
                this.formInline.base_net_price = price.toFixed(4);
                this.formInline.Price = (e*dis).toFixed(4)
                this.formInline.net_Price = ((e*dis)/ (1 + pp)).toFixed(4);
            },
            changeBaseNetPrice(e){
                let that = this
                let pp = 0;
                let dis = this.curratelist.discount
                this.currate.forEach(item => {
                    if (item.currencycode == this.formInline.Currency_Unit) {
                        pp = item.taxrate / 100;
                        that.currencycode = item.currencycode;
                    }
                });
                let price = e * (1 + pp);
                this.formInline.base_price = price.toFixed(4);
                this.formInline.net_Price = (e*dis).toFixed(4)
                this.formInline.Price = ((e*dis)* (1 + pp)).toFixed(4);
            },
            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    if (item.query_Condition == '' || item.query_Condition.length > 0) {
                        pm = {
                            row_sign: item.row_sign,
                            query_Condition: item.query_Condition,
                            query_sort: item.query_sort,
                            query_field_type: item.Query_Field_Type,
                            query_field_name: item.Query_Field_Name
                        };
                        parm.Param.push(pm);
                    }
                });
                // console.log(parm);
                that.$http.urlpost('Sal/Part/DataList', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                });
            },
            // 获取详情
            getdetail(item) {
                let that = this;
                this.isEdit = true;
                let parm = {
                    Id: '',
                    Code: item.Exclusively_Id,
                    Name: '',
                    Where: ''
                };
                that.exclusively_id = item.Exclusively_Id;
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('Sal/Part/GetSalPartInfoByID', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        let hear = res.DataContent.Header[0];
                        that.formInline = hear;
                        that.formInline.Sales_Unit = hear.Sales_Unit;
                        that.formInline.Sales_Type = (that.formInline.Sales_Type == 0?null:that.formInline.Sales_Type)
                        that.formInline.Package = (that.formInline.Package == 0?null:that.formInline.Package)
                        that.Detail = [];
                        let data = res.DataContent.Detail
                        for(let i=0;i<data.length;i++){
                            that.Detail = [...that.Detail,{
                                add: true,
                                _exclusively_id: data[i].Exclusively_ID,
                                _p_part_id: data[i].p_part_ID,
                                _batch_floor_limit: data[i].batch_floor_limit,
                                _price: data[i].price,
                                _net_price: data[i].net_price,
                                _base_price:data[i].base_price,
                                _base_net_price:data[i].base_net_price,
                                _relation_id: data[i].relation_id
                            }]
                        }
                        that.oldFormInline = JSON.stringify(that.formInline)
                        that.authority();
                        that.btnauthority();
                    }
                    loadingInstance.close()
                });
                that.editvisi = true;
            },
            // 编辑
            edit(jsd) {
                // console.log(jsd);
                this.formInline = jsd.row;
                this.isEdit = true;
                this.getdetail(jsd.row);
                this.authority();
            },
            //行编辑
            edits(e) {
                let that = this
                if(that.code == e.Exclusively_Id){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 101, 1)){
                        return
                    }
                    if(that.oldFormInline != JSON.stringify(that.formInline)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.code = e.Exclusively_Id
                                that.oldrow = e
                                this.getdetail(e);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.code = e.Exclusively_Id
                        that.oldrow = e
                        this.getdetail(e);
                    }
                }, 100);
            },
            // 新增
            add() {
                let that = this;
                if(that.oldFormInline != JSON.stringify(that.formInline)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                that.code=''
                this.formInline = {
                    Exclusively_Id: '',
                    Sales_part: '',
                    Part_name: '',
                    Part_Version: '',
                    Cust_Version: '',
                    Field: '',
                    CusPart_ID: '',
                    CusPart_Name: '',
                    Model: '',
                    Spec: '',
                    Sales_Type: null,
                    Part_No: '',
                    HelpCheck_Code: '',
                    Inv_Unit: '',
                    Sales_Unit: '',
                    Change_rate: '',
                    Price: '',
                    net_Price: '',
                    Currency_Unit: '',
                    Package: null,
                    Create_person: '',
                    Create_time: '',
                    Update_person: '',
                    update_time: '',
                    Remark: '',
                    MTL_Master_Unit: '',
                    part_name: '',
                    part_code: '',
                    MTL_Vension: '',
                    item_code: '',
                    item_name: '',
                    audit_status: 0,
                    Quoprice: '',
                    Package_size: 0,
                    processing: '',
                    isestimateprice:0,
                    sales_rate:1,
                    sal_moq:0,
                    isfreeze:0,
                    custdraw_version:'',
                    base_net_price:'',
                    base_price:'',
                };
                this.Detail = []
                /*this.Detail = [
                    {
                        _exclusively_id: '',
                        _p_part_id: 0,
                        _batch_floor_limit: '',
                        _price: 0,
                        _net_price: 0,
                        _relation_id: 0
                    }
                ];*/
                this.editvisi = true;
                this.isEdit = false;
                that.oldFormInline = JSON.stringify(that.formInline)
                this.authority();
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].Exclusively_Id + ',';
                }
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority()
            },
            batchAudit() {
                let that = this
                let parm = {
                    Lists: []
                }
                for (let i = 0; i < that.selectData.length; i++) {
                    parm.Lists = [...parm.Lists, {
                        exclusively_id: that.selectData[i].Exclusively_Id
                    }]
                }
                that.$http.urlpost('/Sal/Part/BatchAuditSalPart', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata()
                    }
                });
            },
            batchUnAudit() {
                let that = this
                let parm = {
                    Lists: []
                }
                for (let i = 0; i < that.selectData.length; i++) {
                    parm.Lists = [...parm.Lists, {
                        exclusively_id: that.selectData[i].Exclusively_Id
                    }]
                }
                that.$http.urlpost('/Sal/Part/BatchUnAuditSalPart', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata()
                    }
                });
            },
            //批量折扣
            batchUpdate(){
                let that = this
                let parm = {}
                that.$http.urlpost('Sal/Part/GetSalLastDiscount', parm, function (res) {
                    if (res.Success == 1) {
                        that.updateVis = true
                        if(res.DataContent.ls.length > 0){
                            that.dataDiscount = []
                            that.dataDiscount= res.DataContent.ls
                            that.updateData.discount = that.dataDiscount[0].discount
                        } else {
                            that.updateData.discount = 1
                        }
                    }
                });
            },
            confirmBatchUpdate(){
                let that = this;
                if(that.updateData.discount >1 || that.updateData.discount<0){
                    that.$message.warning(that.$t('getapi[13010]'))
                    return
                }
                this.$confirm(that.$t('getapi[12920]'), that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            person: that.updateData.person,
                            discount_rate: that.updateData.discount,
                            noadd_flag:0,
                        }
                        that.btn.batchupdate = false
                        that.$http.urlpost('Sal/Part/SalBatchUpdate', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.updateVis = false
                                that.intidata()
                            }
                            that.btn.batchupdate = true
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            //更新折扣价
            salBatchUpdate(){
                let that = this
                this.$confirm(that.$t('getapi[12920]'), that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            person: that.updateData.person,
                            discount_rate: that.updateData.discount,
                            noadd_flag:1,
                        }
                        that.btn.salbatchupdate = false
                        that.$http.urlpost('Sal/Part/SalBatchUpdate', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.intidata()
                            }
                            that.btn.salbatchupdate = true
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            // 删除
            // del() {
            //     let that = this;
            //     let parm = {
            //         Exclusively_ID: that.formInline.Exclusively_Id,
            //         update_time: that.formInline.update_time
            //     };
            //     // let ffd = that.formInline.update_time;
                
            //      that.$http.urlpost('/Sal/Cus/DeleteCusInfo', parm, function(res) {
            //         that.$refs.SetBtn.SetOneBtnEnable('del', true);
            //         if (res.Success == 1) {
            //             that.$message.success(res.Msg);
            //             that.intidata()
            //             that.confirmAdd()
            //         }
            //     });

            //     // $.ajax({
            //     //     url: Common.Url + 'Sal/Cus/DeleteCusInfo?token=' + that.token + '&Exclusively_ID=' + that.ids.Exclusively_Id + '&update_time=' + ffd,
            //     //     type: 'post',
            //     //     async: false,
            //     //     contentType: 'application/json',
            //     //     success: function (res) {
            //     //         if (res.Success == 1) {
            //     //             that.$message.success(that.$t('getapi[659]'));
            //     //             that.datajson.forEach(function (item, index) {
            //     //                 if (that.ids.indexOf(item.Exclusively_Id) >= 0) {
            //     //                     that.datajson.splice(index, 1);
            //     //                 }
            //     //             });
            //     //         } else {
            //     //             that.$message.error(res.Msg);
            //     //         }
            //     //     },
            //     //     error: function (xhr, errorType, error) {
            //     //         //Message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
            //     //     }
            //     // });
            // },
            // // 删除
            // del(jsd) {
            //     let that = this;
            //     this.ids = jsd.row;
            //     that.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            //         confirmButtonText: '确定',
            //         cancelButtonText: '取消',
            //         type: 'warning'
            //     })
            //         .then(() => {
            //             that.delf();
            //         })
            //         .catch(() => {
            //         });
            // },
            // //批量删除
            // delall() {
            //     let that = this;
            //     that.ids = this.selectIDData;
            //     that.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            //         confirmButtonText: '确定',
            //         cancelButtonText: '取消',
            //         type: 'warning'
            //     })
            //         .then(() => {
            //             that.delf();
            //         })
            //         .catch(() => {
            //         });
            // },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'SALPartViewInfo');
            },
            // 刷新
            reflash() {
                /*this.intidata();
                this.authority(1);
                if (this.formInline.Exclusively_Id != '') {
                    this.getdetail(this.formInline);
                } else {
                    this.add()
                }*/
                let that = this;
                if(that.oldFormInline != JSON.stringify(that.formInline)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            this.intidata();
                            this.authority();
                            if (this.formInline.Exclusively_Id != '') {
                                this.getdetail(this.formInline);
                            } else {
                                this.confirmAdd()
                            }
                        });
                } else {
                    this.intidata();
                    this.authority();
                    if (this.formInline.Exclusively_Id != '') {
                        this.getdetail(this.formInline);
                    } else {
                        this.confirmAdd()
                    }
                }
            },
            //打开税收商品弹框
            ssf() {
                this.salssvisi = true;
                this.$refs.input.clearInput(this.salssvisi);
            },
            //获取物料信息
            getitem(val) {
                console.log(val);
                let that = this;
                that.formInline.Part_No = val.exclusively_id;
                that.formInline.Sales_part = val.part_code;
                that.formInline.part_name = val.part_name;
                that.formInline.cust_version = val.part_version;
                that.formInline.Model = val.part_model;
                that.formInline.Spec = val.part_spec;
                that.formInline.item_code = val.item_code;
                that.formInline.item_name = val.item_nam;
                that.formInline.Part_Version = val.part_version;
                that.formInline.Part_name = val.part_name;
                that.formInline.Sales_Unit_Name = val.part_master_unit;
                that.formInline.Inv_Unit_Name = val.part_master_unit;
                that.Inv_Unit.forEach(item => {
                    if (item.Name == val.part_master_unit) {
                        that.formInline.Sales_Unit = item.Num;
                        that.formInline.Inv_Unit = item.Num;
                    }
                });
                //that.formInline.Sales_Unit = val.part_Master_Unit;
                that.formInline.Change_rate = val.field;
                this.formInline.base_net_price = '';
                this.formInline.base_price = '';
            },
            // 保存数据
            save() {
                let that = this;
                console.log(JSON.stringify(that.formInline))
                let parm = that.formInline;
                // parm.Inv_Unit = parm.Inv_Unit_Name;
               /* // 销售件类别空提示
                if (parm.Sales_Type == null || parm.Sales_Type.length < 1) {
                    that.$message.error(that.$t('getapi[8777]'));//'请选择销售件类别'
                    return false;
                }
                // 包装方式空提示
                if (parm.Package == null || parm.Package.length < 1) {
                    that.$message.error(that.$t('getapi[8778]'));//'请选择包装方式'
                    return false;
                }*/
                // 销售计量单位空提示
                if (parm.Sales_Unit == null || parm.Sales_Unit.length < 1) {
                    that.$message.error(that.$t('getapi[8779]'));//'请选择销售计量单位'
                    return false;
                }
                // 货币空提示
                if (parm.Currency_Unit == null || parm.Currency_Unit.length < 1) {
                    that.$message.error(that.$t('getapi[8780]'));//'请选择货币'
                    return false;
                }
                for(let i=0;i<that.Detail.length;i++){
                    if (that.Detail[i]._batch_floor_limit == ''|| that.Detail[i]._batch_floor_limit == 0){
                        that.$message.error(that.$t('getapi[530]') + (i+1) + that.$t('getapi[8781]'));//行批量下限不能为空
                        return false;
                    }
                }

                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.loading = true;
                let ppms = {
                    Head: '',
                    Lists: []
                };
                ppms.Head = parm;
                // ppms.Lists = that.Detail;
                that.Detail.forEach(item => {
                    // if (item.add) {
                    item._p_part_id = that.formInline.Part_No;
                    ppms.Lists.push(item);
                    // }
                });
                let parms = JSON.stringify(ppms);
                var reg = new RegExp('null', 'g'); //创建正则baiRegExp对象
                parms = parms.replace(reg, '""');
                //console.log(parms);
                let pm = JSON.parse(parms);
                pm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/Sal/Part/SaveData', pm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.intidata();
                        pm.Head.Exclusively_Id = res.UniqueNum;
                        that.getdetail(pm.Head);
                        that.loading = false;
                        that.editvisi = false;
                    } else {
                        that.loading = false;
                    }
                });
                that.$refs.SetBtn.SetOneBtnEnable('save', true);
            },
            // 操作
            handleCommand(key) {
                console.log(key);
                let that = this;
                let ffd = that.formInline.update_time;
                let userData = sessionStorage.getItem('userData');
                that.token = JSON.parse(userData).token;
                $.ajax({
                    url: Common.Url + '/Sal/Part/AuditSalPart?token=' + that.token + '&Exclusively_ID=' + that.formInline.Exclusively_Id + '&update_time=' + ffd + '&auditFlag=' + key,
                    type: 'post',
                    async: false,
                    contentType: 'application/json',
                    success: function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[8782]'));//'操作成功'
                            that.intidata();
                            that.getdetail(that.formInline);
                            that.authority();
                        } else {
                            that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    },
                    error: function (xhr, errorType, error) {
                        //Message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                    }
                });
                // this.formInline.audit_status = key;
            },
            imp() {                
                let item = {
                    //label: '销售件导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/12',
                    url: '/exp/12',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/12'});
                this.$store.commit('selectMenu', item);
            },
            //导出·
            exp() {
                /*let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    if (item.query_Condition == '' || item.query_Condition.length > 0) {
                        pm = {
                            row_sign: item.row_sign,
                            query_Condition: item.query_Condition,
                            query_sort: item.query_sort,
                            query_field_type: item.Query_Field_Type,
                            query_field_name: item.Query_Field_Name
                        };
                        parm.Param.push(pm);
                    }
                });
                // console.log(parm);
                that.$http.urlpost('Sal/Part/ExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    } else {
                        that.$message.error(res.Msg);
                    }
                    that.loading = false;
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "SALPartViewInfo",
                    fromname: that.$t('getapi[999]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            show(ev, row) {
                let that = this;
                that.edit(row);
            },
            shows(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = this.datajson[index - 1];
                    this.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = this.datajson[index + 1];
                    this.setCurrent(tds);
                }
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                // console.log(val, this.datajson);
                let result = this.datajson.findIndex(item => item.Exclusively_Id === val.Exclusively_Id);
                //this.indf = result;

                let fsd = document.getElementsByClassName('fsd');
                fsd[result].focus();
                this.currentRow = val;
            },
            cahngeprice(data) {
                let that = this;
                let pp = 0;
                this.currate.forEach(item => {
                    if (item.currencycode == this.formInline.Currency_Unit) {
                        pp = item.taxrate / 100;
                        that.currencycode = item.currencycode;
                    }
                });
                if (!that.$limits.fnIsEmpty(that.Detail[data.$index]._price)) {
                    if (that.formInline.Currency_Unit != that.currencycode) {
                        that.Detail[data.$index]._net_price = (parseFloat(that.Detail[data.$index]._price));
                    }
                    else {
                        that.Detail[data.$index]._net_price = (that.Detail[data.$index]._price / (1 + pp)).toFixed(4);
                    }
                    that.Detail[data.$index]._base_price = ''
                    that.Detail[data.$index]._base_net_price = ''
                }
            },
            cahngenetprice(data) {
                let that = this;
                let pp = 0;
                this.currate.forEach(item => {
                    if (item.currencycode == this.formInline.Currency_Unit) {
                        pp = item.taxrate / 100;
                        that.currencycode = item.currencycode;
                    }
                });
                if (!that.$limits.fnIsEmpty(that.Detail[data.$index]._net_price)) {
                    if (that.formInline.Currency_Unit != that.currencycode) {
                        that.Detail[data.$index]._price = (parseFloat(that.Detail[data.$index]._net_price));
                    }
                    else {
                        that.Detail[data.$index]._price = (that.Detail[data.$index]._net_price * (1 + pp)).toFixed(4);
                    }
                    that.Detail[data.$index]._base_price = ''
                    that.Detail[data.$index]._base_net_price = ''
                }
            },
            changebaseprice(data){
                let that = this;
                let pp = 0;
                let dis = this.curratelist.discount
                this.currate.forEach(item => {
                    if (item.currencycode == this.formInline.Currency_Unit) {
                        pp = item.taxrate / 100;
                        that.currencycode = item.currencycode;
                    }
                });
                if (!that.$limits.fnIsEmpty(that.Detail[data.$index]._base_price)) {
                    if (that.formInline.Currency_Unit != that.currencycode) {
                        that.Detail[data.$index]._base_net_price = (parseFloat(that.Detail[data.$index]._base_price)).toFixed(4);
                        that.Detail[data.$index]._price = (that.Detail[data.$index]._base_price * dis).toFixed(4)
                        that.Detail[data.$index]._net_price = (that.Detail[data.$index]._base_price * dis).toFixed(4)
                    }
                    else {
                        that.Detail[data.$index]._base_net_price = (that.Detail[data.$index]._base_price / (1 + pp)).toFixed(4);
                        that.Detail[data.$index]._price = (that.Detail[data.$index]._base_price * dis).toFixed(4)
                        that.Detail[data.$index]._net_price = ((that.Detail[data.$index]._base_price * dis)/ (1 + pp)).toFixed(4)
                    }
                }
            },
            changebasenetprice(data){
                let that = this;
                let pp = 0;
                let dis = this.curratelist.discount
                this.currate.forEach(item => {
                    if (item.currencycode == this.formInline.Currency_Unit) {
                        pp = item.taxrate / 100;
                        that.currencycode = item.currencycode;
                    }
                });
                if (!that.$limits.fnIsEmpty(that.Detail[data.$index]._base_net_price)) {
                    if (that.formInline.Currency_Unit != that.currencycode) {
                        that.Detail[data.$index]._base_price = (parseFloat(that.Detail[data.$index]._base_net_price));
                        that.Detail[data.$index]._price = (that.Detail[data.$index]._base_price * dis).toFixed(4)
                        that.Detail[data.$index]._net_price = (that.Detail[data.$index]._base_price * dis).toFixed(4)
                    }
                    else {
                        that.Detail[data.$index]._base_price = (that.Detail[data.$index]._base_net_price * (1 + pp)).toFixed(4);
                        that.Detail[data.$index]._net_price = (that.Detail[data.$index]._base_net_price * dis).toFixed(4)
                        that.Detail[data.$index]._price = ((that.Detail[data.$index]._base_net_price * dis)* (1 + pp)).toFixed(4)
                    }
                }
            },
            //货币值发生变化事件
            currencycodeChange(e) {
                let that = this
                that.currencycode = e;
                if (!that.$limits.fnIsEmpty(that.currencycode)) {
                    that.formInline.Price = 0;
                    that.formInline.net_Price = 0;
                    that.formInline.base_price = '';
                    that.formInline.base_net_price = '';
                    for (var i = 0; that.Detail.length; i++) {
                        that.Detail[i]._price = 0;
                        that.Detail[i]._net_price = 0;
                        that.Detail[i]._base_price = '';
                        that.Detail[i]._base_net_price = '';
                    }
                }
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 101,1) < 1){
                    return false
                }
                let flag =  that.oldFormInline != JSON.stringify(that.formInline)
                return flag
            }
        }
    };
</script>

<style lang="scss" scoped>
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        .bbl {
            margin: 0px auto 10px;
            white-space: pre;
            span {
                margin-left: 20px;
                min-width: 70px;
                text-align: left;
                line-height: 20px;
                display: inline-block;
                margin-right: 5px;
            }
        }
    }
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
